import { ArchivaceCertifikatVyhledaniDto, CertifikatVyhledaniDto } from '@generated/be';
import { WithMinus } from '@shared/utils';

export const CERT_SORTING_TYPE_ARCHIV_DEFAULT: WithMinus<keyof ArchivaceCertifikatVyhledaniDto> = '-datumZmeny';
export const CERT_SORTING_TYPE_DEFAULT: WithMinus<keyof CertifikatVyhledaniDto> = '-platnostRegistraceOd';

export const urovenZarukyCertifikatu: Record<string, string> = {
  '1': 'Nízká',
  '2': 'Značná',
  '3': 'Vysoká',
};
